export default function includes(needle, haystack) {
  return haystack.toLowerCase().indexOf(needle.toLowerCase()) >= 0;
}
